import { DropzoneFile } from 'components/Dropzone/utils';
import { ObjectValues } from 'types';
import { User } from './User';
import { Listing } from './Listing';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { LeadNdaProps, SoftSignal } from './Lead';
import { EnquiryQuestionType } from 'router/subrouters/Dash/subrouters/Business/components/EnquirySlider/utils';
import { UploadedFile } from './File';
import { ReactionType } from './Reactions';

export const MESSAGE_STATUS_INDICATOR = {
  ERROR: 'ERROR',
  NOT_SENT: 'NOT_SENT',
} as const;

type MessageStatusIndicator = ObjectValues<typeof MESSAGE_STATUS_INDICATOR>;

export type DocumentFile = { fileName: string; file: DropzoneFile };

export type MessageType = {
  _id: string;
  text: string;
  userId: string;
  sessionId: string;
  session: SessionType;
  createdAt?: string;
  updatedAt?: string;
  statusIndicator: MessageStatusIndicator;
  showDate?: string;
  files: MessageFileType[];
  isInterestContext?: boolean;
  softSignal?: SoftSignal;
  dataRoomNodeId?: string;
  dataRoomNode?: DataRoomNode;
  dataRoomNodeName?: string;
  seenAt?: Date;
  isPulseCheck?: boolean;
  isDeleted?: boolean;
  reaction: ReactionType;
};

type KeyMessagingType = {
  interlocutor: User;

  isBuyer?: boolean; // false for 3rd party and sell side users
  buyerId?: string;
  leadId?: string;

  listing?: Listing;
};

export type SessionType = {
  id: string;

  isDirectMessage?: boolean; // user - user chat, no deal

  latestMessageAt: Date;
  hasUnreadMessages: boolean;

  enquiryQuestions: EnquiryQuestionType[];
  dataRoomNodes: DataRoomNode[];
  leadWithdrawnInterest?: boolean;
  isExternalCommunication?: boolean;
  isClosed?: boolean;
  dealRoomOwnerName?: string;
  manuallySetNDAStatus?: boolean;
} & KeyMessagingType &
  LeadNdaProps;

export type UserConnection = {
  _id: string;
  session: SessionType;
} & KeyMessagingType;

export type MessageFileType = DropzoneFile & {
  chatSessionFileId?: string;
};

export type ChatSessionFile = UploadedFile & {
  sessionId: string;
};

export const MESSAGE_LOCATION = {
  MESSAGING_PAGE: 'Messaging page',
  LEADS_PAGE: 'Leads page',
  DATA_ROOM: 'Data Room',
} as const;

export type MessageLocation = ObjectValues<typeof MESSAGE_LOCATION>;
